var React = require('react');

function TracePlay (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1876_27603)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M73.0218 34.4283H108.36V72.1471H73.0218V106.82H35.5471V72.1471H0.20874V34.4283H35.5471V0.741211H73.0218V34.4283ZM35.5534 71.6081V35.054C35.5534 34.6061 36.0874 34.4269 36.4435 34.5165L72.672 52.7935C73.1171 53.0623 73.1171 53.5999 72.672 53.779L36.4435 72.0561C36.0874 72.3249 35.5534 72.0561 35.5534 71.6081Z","fill":"#2F3139"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1876_27603"},React.createElement("rect",{"width":"109","height":"107","fill":"white"})))]);
}

TracePlay.defaultProps = {"width":"109","height":"107","viewBox":"0 0 109 107","fill":"none"};

module.exports = TracePlay;

TracePlay.default = TracePlay;
